import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const Wrapper = styled(Box)(() => ({
  display: "flex",
  height: '100vh',
  flexDirection: "column",
}));
